import { render, staticRenderFns } from "./releaseRecord.vue?vue&type=template&id=8e377444&scoped=true&"
import script from "./releaseRecord.vue?vue&type=script&lang=js&"
export * from "./releaseRecord.vue?vue&type=script&lang=js&"
import style0 from "./releaseRecord.vue?vue&type=style&index=0&id=8e377444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e377444",
  null
  
)

export default component.exports